import { getUserAuthToken } from 'helpers/StorageHelper';
import { type PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { customerMainRoutes } from './CustomerRoutes';

// import { useAppSelector } from 'store/hooks';
// import { userInfoSelector } from 'store/auth/selectors/authSelectors';
const ProtectedCustomerRoute = ({ children }: PropsWithChildren) => {
  // const userInfo = useAppSelector(userInfoSelector);
  const user = getUserAuthToken();
  if (!user) {
    // not logged in so redirect to Home page with the return url
    return <Navigate to={customerMainRoutes.customerHome.path} replace />;
  } else {
    return children;
  }
};
export default ProtectedCustomerRoute;
